import React from 'react'
import { useHistory } from 'react-router-dom'

import { IButton } from '@/Components/ResourcesCncPageComponents/ContentBodyHeader/ContentBodyHeader'
import ContentHeader from '@/Layouts/MainLayout/components/ContentHeader'
import useTranslation from '@/Hooks/UseTranslation'
import { useProject } from '@/Hooks/UseProject'

import './ProjectOverviewHeader.scss'

type OverviewTab = 'dashboard' | 'indicators'

interface Props {
  activeTab: OverviewTab
  buttons?: IButton[]
}

const ProjectOverviewHeader = ({ activeTab, buttons }: Props) => {
  const history = useHistory()
  const { t } = useTranslation()
  const { project_id } = useProject()

  const handleChangeTab = (tab: string) => {
    if (!project_id || tab === activeTab) return

    history.push(
      tab === 'indicators'
        ? `/project/${project_id}/indicators/ppc`
        : `/project/${project_id}/`,
    )
  }

  return (
    <ContentHeader
      className="project-overview-header pl4-page-header"
      title={t('PROJECT_OVERVIEW:PageTitle')}
      buttons={buttons?.filter(button => button.visible).map(button => ({
        label: button.label,
        icon: button.icon,
        onClick: button.onClick,
        disabled: button.disabled,
        active: button.active,
        className: `pl4-page-action--${button.variant || 'primary'}`,
      }))}
      navTabs={[
        {
          label: t('NAVIGATION:ProjectDashboard'),
          icon: <span className="icon-dashboard" />,
          active: activeTab === 'dashboard',
          onClick: () => handleChangeTab('dashboard'),
        },
        {
          label: t('NAVIGATION:Indicators'),
          icon: <span className="icon-indicadores" />,
          active: activeTab === 'indicators',
          onClick: () => handleChangeTab('indicators'),
        },
      ]}
    />
  )
}

export default ProjectOverviewHeader
